import { render, staticRenderFns } from "./login.vue?vue&type=template&id=631cd741&scoped=true&"
import script from "./login.vue?vue&type=script&setup=true&lang=js&"
export * from "./login.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=631cd741&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631cd741",
  null
  
)

export default component.exports